export function computeEditPermission(vehiclesCount: number, isLoadingGpsData: boolean) {
  if (isLoadingGpsData) return 'disabledLoadingGpsData'
  if (vehiclesCount !== 1) return 'disabledMultipleVehicles'
  return 'enabled'
}
